<template>
    <ul class="tab-list tab-list--block">
        <li
            v-for="category in categories._parents"
            :key="category._id"
            :class="{ on: category._id == categories.selected._parent._id }"
            @click="$emit('set-category-parent', category)"
        >
            <button class="button" type="button">{{ category.name }}</button>
        </li>
    </ul>
</template>
<script>
export default {
    props: {
        categories: {
            _parents: Array,
            _children: Array,
            selected: {
                _parent : Object,
                _child : Object
            }
        },
    }
};
</script>